import { SEOHead } from "@/components/SEOHead";
import { CompanyHero } from "@/components/home/CompanyHero";
import { SocialProofSection } from "@/components/home/SocialProofSection";

export default function Index() {
  return (
    <>
      <SEOHead
        title="Proton Health Labs™ | Brain Charge™ Stimulant-Free Cognitive Support"
        ogTitle="Be a Proton™ — Always Positive | Proton Health Labs™"
        ogDescription="A positive lifestyle brand built around better performance, resilience and forward motion. Meet Brain Charge™, our transparent, stimulant-free cognitive support formula."
        description="Veteran-founded positive lifestyle supplement company behind Brain Charge™, stimulant-free cognitive support with disclosed doses and no proprietary blends."
        canonical="https://protonhealthlabs.com/"
        type="website"
        image="https://protonhealthlabs.com/og/proton-home-social.jpg"
      />
      <div className="min-h-screen bg-background">
        <CompanyHero />
        <SocialProofSection />
      </div>
    </>
  );
}
